export class VolumeToMilligramsConstants {
    public static readonly FLUID_OUNCE = 29.574;
    public static readonly PINT = 473.176;
    public static readonly LITRE = 1000.0;
    public static readonly CENTILITRE = 10.0;
    public static readonly GALLON = 3785.41;
    public static readonly MILLILITRE = 1.0;
}

export class WeightToMilligramsConstants {
    public static readonly OUNCE = 28349.5;
    public static readonly MILLIGRAM = 1.0;
    public static readonly KILOGRAM = 1000000.0;
    public static readonly POUND = 453592.0;
    public static readonly GRAM = 1000.0;
}
